<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="formSubmitting"
  [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">

      <form [formGroup]="form">
        <div class="form-group row">
          <app-input [label]="'name'" [formControl]="form_name" size="6"></app-input>
          <app-input [label]="'description'" [formControl]="form_description" size="6"></app-input>
          <app-select [label]="'type'" [formControl]="form_type" [list]="typeList" [isEnum]="true" [isMultiple]="false"
            enumName="PropertyEquipmentType" size="4"></app-select>
          <app-select [label]="'energyType'" [formControl]="form_energyType" [list]="energyTypeList" [isEnum]="true"
            [isMultiple]="false" enumName="EnergyType" size="4"></app-select>
          <app-select [label]="'energyClassification'" [formControl]="form_energyClassification"
            [list]="energyClassificationList" [isEnum]="true" enumName="EnergyClassification" [isMultiple]="false"
            size="4"> </app-select>
          <app-select [label]="'status'" [formControl]="form_status" [list]="statusList" [isEnum]="true"
            [isMultiple]="false" enumName="PropertyEquipmentStatus" size="4"></app-select>
        </div>

        <p>Identification</p>
        <div class="form-group row">
          <app-input [label]="'brand'" [formControl]="form_brand" size="4"></app-input>
          <app-input [label]="'model'" [formControl]="form_model" size="4"></app-input>
          <app-input [label]="'power'" [formControl]="form_power" size="4" suffixText="W"></app-input>
          <app-input [label]="'serialNumber'" [formControl]="form_serialNumber" size="4"></app-input>
        </div>

        <p>Installation</p>
        <div class="form-group row">
          <app-input type="date" [label]="'dateInstallation'" [formControl]="form_dateInstallation"
            size="4"></app-input>
          <app-input type="date" [label]="'dateRemoval'" [formControl]="form_dateRemoval" size="4"></app-input>
          <app-input type="date" [label]="'datePurchase'" [formControl]="form_datePurchase" size="4"></app-input>
          <app-input [label]="'cost'" [formControl]="form_cost" suffixIcon="euro" size="4"></app-input>
          <app-input [label]="'warrantyPeriod'" [formControl]="form_warrantyPeriod" suffixText="mois"
            size="4"></app-input>
        </div>
        <p>Documents</p>
        <div class="form-group row">
          <ng-container *ngFor="let doc of documents">
            <app-doc-add-widget class="col-12 col-lg-6 col-xl-3" [prop]="data.prop" category="EQUIPMENT"
              title="{{ 'enum.DocumentType.'+doc.type | translate }}" (docDeleted)="onExistingDocDeleted($event)"
              [withSelect]="true" [document]="doc"></app-doc-add-widget>
          </ng-container>
          <ng-container *ngFor="let count of newDocumentsCount">
            <app-doc-add-widget class="col-12 col-lg-6 col-xl-3" [prop]="data.prop" category="EQUIPMENT" title="Nouveau"
              (docSelected)="onNewDocSelected($event)" (docDeleted)="onNewDocDeleted($event)"
              [withSelect]="true"></app-doc-add-widget>
          </ng-container>
        </div>

      </form>
    </div>
  </div>
</ng-template>